

















































import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import BaseInput from "@/app/core/component/BaseInput.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import VueEvent from "@/app/core/decorator/VueEvent";
import { StoreUseData } from "@/@types/store";
import { MediaInfo } from "@/@types/room";
import { getYoutubeThunbnail } from "@/app/basic/cut-in/bgm/YoutubeManager";
import LanguageManager from "@/LanguageManager";
import GameObjectManager from "@/app/basic/GameObjectManager";
import SButton from "@/app/basic/common/components/SButton.vue";
import { permissionCheck } from "@/app/core/api/app-server/SocketFacade";

@Component({
  components: { SButton, BaseInput, CtrlButton }
})
export default class MediaItemComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: Object, required: true })
  private media!: StoreUseData<MediaInfo>;

  @Prop({ type: Boolean, required: true })
  private isViewThumbnail!: boolean;

  @VueEvent
  private get typeStr(): string {
    const type = this.media.data!.type;
    let target = "label.";
    switch (type) {
      case "image":
      case "music":
      case "setting":
      case "youtube":
        target += type;
        break;
      default:
        target += "unknown";
    }
    return LanguageManager.instance.getText(target);
  }

  @VueEvent
  private get tagStr(): string {
    const tag = this.media.data!.tag;
    return tag || LanguageManager.instance.getText("label.non-tag");
  }

  @VueEvent
  private get ownerStr(): string {
    return GameObjectManager.instance.getUserName(this.media.owner);
  }

  @VueEvent
  private get iconClass(): string | undefined {
    const type = this.media.data!.type;
    if (type === "image")
      return this.isViewThumbnail ? undefined : "icon-image";
    if (type === "music") return "icon-music";
    if (type === "setting") return "icon-text";
    if (type === "youtube")
      return this.isViewThumbnail ? undefined : "icon-youtube";
    return "icon-warning";
  }

  @VueEvent
  private get thumbnailSrc(): string {
    const type = this.media.data!.type;
    const url = this.media.data!.url;
    if (type === "youtube") return getYoutubeThunbnail(url);
    if (type === "image") return url;
    return "";
  }

  @VueEvent
  private get isEditable() {
    return permissionCheck(this.media, "edit");
  }

  @VueEvent
  private get isChmodAble() {
    return permissionCheck(this.media, "chmod");
  }

  @VueEvent
  private get isDeletable() {
    return permissionCheck(this.media, "edit");
  }
}
